import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Features from 'components/features';
import AuditLogs from 'components/audit-logs';
import Applications from 'components/applications';
import NotFound from 'components/not-found';
import Index from 'components/index';
import * as constants from 'app-constants';

export default function AppRoutes() {
  return (
    <Switch>
      <Route path={constants.PATH_FEATURES} component={Features} />
      <Route path={constants.PATH_APPLICATIONS} component={Applications} />
      <Route path={constants.PATH_AUDIT_LOGS} component={AuditLogs} />
      <Route exact path="/" component={Index} />
      <Route component={NotFound} />
    </Switch>
  );
}
